import { useState, useEffect, Fragment } from 'react';

export const EFKALoader = () => {
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);

  const groups = [
    {
      colors: ['#f15025', '#f26422', '#b6558a'], // Dark Orange cubicle
      paths: [
        'M 62.5,11.5 C 63.5981,12.397 63.5981,13.2303 62.5,14C 56.434,18.0319 50.1007,21.5319 43.5,24.5C 36.3423,21.0883 29.3423,17.4216 22.5,13.5C 22.5,13.1667 22.5,12.8333 22.5,12.5C 29.3119,8.25802 36.3119,4.25802 43.5,0.5C 50.1079,3.79282 56.4412,7.45949 62.5,11.5 Z',
        'M 62.5,11.5 C 63.4916,11.3284 64.1583,11.6618 64.5,12.5C 64.5,20.8333 64.5,29.1667 64.5,37.5C 57.8333,41.5 51.1667,45.5 44.5,49.5C 44.1667,49.5 43.8333,49.5 43.5,49.5C 43.5,41.1667 43.5,32.8333 43.5,24.5C 50.1007,21.5319 56.434,18.0319 62.5,14C 63.5981,13.2303 63.5981,12.397 62.5,11.5 Z',
        'M 22.5,13.5 C 29.3423,17.4216 36.3423,21.0883 43.5,24.5C 43.5,32.8333 43.5,41.1667 43.5,49.5C 36.3372,45.7529 29.3372,41.7529 22.5,37.5C 22.5,29.5 22.5,21.5 22.5,13.5 Z'
      ]
    },
    {
      colors: ['#f26422', '#f79422', '#d08a2c'], // Light Orange cubicle
      paths: [
        'M 62.5,11.5 C 63.4916,11.3284 64.1583,11.6618 64.5,12.5C 64.5,20.8333 64.5,29.1667 64.5,37.5C 57.8333,41.5 51.1667,45.5 44.5,49.5C 44.1667,49.5 43.8333,49.5 43.5,49.5C 43.5,41.1667 43.5,32.8333 43.5,24.5C 50.1007,21.5319 56.434,18.0319 62.5,14C 63.5981,13.2303 63.5981,12.397 62.5,11.5 Z',
        'M 64.5,12.5 C 71.6929,16.349 78.8596,20.349 86,24.5C 86.4997,32.8267 86.6664,41.16 86.5,49.5C 86.1667,49.5 85.8333,49.5 85.5,49.5C 78.6354,45.2352 71.6354,41.2352 64.5,37.5C 64.5,29.1667 64.5,20.8333 64.5,12.5 Z',
        'M 64.5,37.5 C 71.6354,41.2352 78.6354,45.2352 85.5,49.5C 78.9965,54.2552 71.9965,58.2552 64.5,61.5C 57.4661,57.9885 50.7994,53.9885 44.5,49.5C 51.1667,45.5 57.8333,41.5 64.5,37.5 Z'
      ]
    },
    {
      colors: ['#0bb5ab', '#16b28e', '#d08a2c'], // Green cubicle
      paths: [
        'M 43.5,49.5 C 43.8333,49.5 44.1667,49.5 44.5,49.5C 50.7994,53.9885 57.4661,57.9885 64.5,61.5C 65.1382,69.5994 65.8048,77.5994 66.5,85.5C 66.1667,86.5 65.5,87.1667 64.5,87.5C 58.039,82.4291 51.039,78.0958 43.5,74.5C 43.5,66.5 43.5,58.5 43.5,50.5C 43.5,50.1667 43.5,49.8333 43.5,49.5 Z',
        'M 85.5,49.5 C 85.8333,49.5 86.1667,49.5 86.5,49.5C 86.8314,58.1922 86.498,66.8589 85.5,75.5C 79.2709,79.1137 72.9376,82.447 66.5,85.5C 65.8048,77.5994 65.1382,69.5994 64.5,61.5C 71.9965,58.2552 78.9965,54.2552 85.5,49.5 Z',
        'M 64.5,37.5 C 71.6354,41.2352 78.6354,45.2352 85.5,49.5C 78.9965,54.2552 71.9965,58.2552 64.5,61.5C 57.4661,57.9885 50.7994,53.9885 44.5,49.5C 51.1667,45.5 57.8333,41.5 64.5,37.5 Z'
      ]
    },
    {
      colors: ['#15aeef', '#0189cf', '#0bb5ab'], // Light Blue cubicle
      paths: [
        'M 43.5,74.5 C 51.039,78.0958 58.039,82.4291 64.5,87.5C 57.4661,91.0115 50.7994,95.0115 44.5,99.5C 43.8333,99.5 43.1667,99.5 42.5,99.5C 35.6676,94.9161 28.6676,90.5827 21.5,86.5C 28.8063,82.5123 36.1396,78.5123 43.5,74.5 Z',
        'M 43.5,50.5 C 43.5,58.5 43.5,66.5 43.5,74.5C 36.1396,78.5123 28.8063,82.5123 21.5,86.5C 20.8333,86.5 20.5,86.1667 20.5,85.5C 22.4668,77.9032 23.1335,69.9032 22.5,61.5C 29.3691,57.5656 36.3691,53.8989 43.5,50.5 Z',
        'M 43.5,49.5 C 43.8333,49.5 44.1667,49.5 44.5,49.5C 50.7994,53.9885 57.4661,57.9885 64.5,61.5C 65.1382,69.5994 65.8048,77.5994 66.5,85.5C 66.1667,86.5 65.5,87.1667 64.5,87.5C 58.039,82.4291 51.039,78.0958 43.5,74.5C 43.5,66.5 43.5,58.5 43.5,50.5C 43.5,50.1667 43.5,49.8333 43.5,49.5 Z'
      ]
    },
    {
      colors: ['#0b65b3', '#0189cf', '#602d90'], // Dark Blue cubicle
      paths: [
        'M 1.5,50.5 C 8.34232,54.4216 15.3423,58.0883 22.5,61.5C 23.1335,69.9032 22.4668,77.9032 20.5,85.5C 14.1698,82.6704 8.16981,79.337 2.5,75.5C 1.53141,67.2517 1.19808,58.9183 1.5,50.5 Z',
        'M 43.5,50.5 C 43.5,58.5 43.5,66.5 43.5,74.5C 36.1396,78.5123 28.8063,82.5123 21.5,86.5C 20.8333,86.5 20.5,86.1667 20.5,85.5C 22.4668,77.9032 23.1335,69.9032 22.5,61.5C 29.3691,57.5656 36.3691,53.8989 43.5,50.5 Z',
        'M 22.5,37.5 C 29.3372,41.7529 36.3372,45.7529 43.5,49.5C 43.5,49.8333 43.5,50.1667 43.5,50.5C 36.3691,53.8989 29.3691,57.5656 22.5,61.5C 15.3423,58.0883 8.34232,54.4216 1.5,50.5C 1.5,50.1667 1.5,49.8333 1.5,49.5C 8.32929,45.2505 15.3293,41.2505 22.5,37.5 Z'
      ]
    },
    {
      colors: ['#602d90', '#9055a1', '#b6558a'], // Purple cubicle
      paths: [
        'M 22.5,37.5 C 29.3372,41.7529 36.3372,45.7529 43.5,49.5C 43.5,49.8333 43.5,50.1667 43.5,50.5C 36.3691,53.8989 29.3691,57.5656 22.5,61.5C 15.3423,58.0883 8.34232,54.4216 1.5,50.5C 1.5,50.1667 1.5,49.8333 1.5,49.5C 8.32929,45.2505 15.3293,41.2505 22.5,37.5 Z',
        'M 22.5,12.5 C 22.5,12.8333 22.5,13.1667 22.5,13.5C 22.5,21.5 22.5,29.5 22.5,37.5C 15.3293,41.2505 8.32929,45.2505 1.5,49.5C 1.16667,49.5 0.833333,49.5 0.5,49.5C 0.168791,41.1401 0.502124,32.8068 1.5,24.5C 8.36456,20.2352 15.3646,16.2352 22.5,12.5 Z',
        'M 22.5,13.5 C 29.3423,17.4216 36.3423,21.0883 43.5,24.5C 43.5,32.8333 43.5,41.1667 43.5,49.5C 36.3372,45.7529 29.3372,41.7529 22.5,37.5C 22.5,29.5 22.5,21.5 22.5,13.5 Z'
      ]
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveGroupIndex((prevIndex) => (prevIndex + 1) % groups.length);
    }, 300);
    return () => clearInterval(interval);
  }, [groups.length]);

  return (
    <Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="150px"
        height="150px"
        viewBox="0 0 100 100"
        style={{
          shapeRendering: 'geometricPrecision',
          textRendering: 'geometricPrecision',
          fillRule: 'evenodd',
          clipRule: 'evenodd'
        }}
      >
        {groups.map((group, index) => (
          <g
            key={index}
            style={{
              opacity: activeGroupIndex === index ? 1 : 0.2
            }}
          >
            {group.colors.map((color, colorIndex) => (
              <path key={colorIndex} fill={color} d={group.paths[colorIndex]} />
            ))}
          </g>
        ))}
      </svg>
    </Fragment>
  );
};
